import { useTranslation } from "react-i18next";
import { TestimonialProps } from "../types/testimonials";

export const useRingTestimonials = (): TestimonialProps[] => {
    const { t } = useTranslation("ringTestimonials");

    // Get testimonials from current language
    const testimonials = t("testimonials", { returnObjects: true }) as Array<{
        quote: string;
        name: string;
        role: string;
    }>;

    // Safety check
    if (!Array.isArray(testimonials)) {
        return [];
    }

    // Map to TestimonialProps format
    return testimonials.map((item, index) => ({
        quote: item.quote,
        name: item.name,
        role: item.role,
        avatar: `/media/landing/avatar${index + 1}.png`,
        rating: index < 5 ? 5 : 4,
        index,
    }));
};

// Export static data for backward compatibility (optional)
export const ringTestimonials: TestimonialProps[] = [
    {
        quote: "حلقه دلبند، پایش خواب من را به سطح جدیدی رسانده است. حالا با تحلیل دقیق مراحل خواب، هر روز با انرژی بیشتری بیدار می‌شوم.",
        name: "سارا احمدی",
        role: "متخصص سلامت و تندرستی",
        avatar: "/public/media/landing/avatar1.png",
        rating: 5,
        index: 0,
    },
    {
        quote: "پایش مداوم اکسیژن خون و ضربان قلب، به من کمک می‌کند تا در طول تمرینات ورزشی، عملکردم را بهینه کنم و از سلامت قلبم مطمئن باشم.",
        name: "علی کریمی",
        role: "ورزشکار حرفه‌ای",
        avatar: "/public/media/landing/avatar2.png",
        rating: 5,
        index: 1,
    },
    {
        quote: "قابلیت ECG این حلقه، آرامش خاطر بی‌نظیری به من می‌دهد. می‌توانم در هر زمان نوار قلبم را بررسی کنم و از وضعیت قلبم آگاه باشم.",
        name: "مریم رضایی",
        role: "بیمار قلبی",
        avatar: "/public/media/landing/avatar3.png",
        rating: 4,
        index: 2,
    },
    {
        quote: "HRV و پایش استرس، به من کمک می‌کند تا سطح استرسم را مدیریت کنم و از فرسودگی شغلی جلوگیری کنم. یک ابزار عالی برای حفظ آرامش.",
        name: "رضا حسینی",
        role: "مدیر پروژه",
        avatar: "/public/media/landing/avatar4.png",
        rating: 5,
        index: 3,
    },
    {
        quote: "برای سلامت بانوان، این حلقه یک ابزار ضروری است. ردیابی چرخه قاعدگی و علائم، بسیار دقیق و کاربردی است و به من در برنامه‌ریزی کمک می‌کند.",
        name: "فاطمه نوری",
        role: "پزشک متخصص زنان",
        avatar: "/public/media/landing/avatar5.png",
        rating: 5,
        index: 4,
    },
    {
        quote: "قدم‌شمار دقیق و مودهای ورزشی متنوع، انگیزه من را برای فعالیت بیشتر افزایش داده است. حالا هر روز اهداف جدیدی برای خودم تعیین می‌کنم.",
        name: "محسن رضایی",
        role: "علاقه‌مند به تناسب اندام",
        avatar: "/public/media/landing/avatar6.png",
        rating: 4,
        index: 5,
    },
    {
        quote: "پایش دمای پوست و تشخیص افتادن، امنیت من را در خانه تضمین می‌کند. یک ابزار عالی برای سالمندان و افرادی که تنها زندگی می‌کنند.",
        name: "خانم شریفی",
        role: "بازنشسته فعال",
        avatar: "/public/media/landing/avatar7.png",
        rating: 5,
        index: 6,
    },
];
